import { useEffect, useState } from "react";
import "./CallForm.css";
import type { CallFormTabs, ICallFormProps } from "./CallForm.interface";
import CallFormTab from "../../components/call-form-tabs/FormTab";
import CallMapTab from "../../components/call-form-tabs/MapTab";
import type { IClientData } from "./ChatForm.interface";
import { clientDataStatuses, type ILeadData } from "../../App.interface";
import api from "../../api/axios";
import InfoPopup from "../../components/InfoPopup";

const CallForm = ({ leadId, phone }: ICallFormProps) => {
  const [activeTab, setActiveTab] = useState<CallFormTabs>("form");

  const [contactId, setContactId] = useState<number | null>(null);

  const [incomingFieldValues, setIncomingFieldValues] =
    useState<ILeadData | null>(null);

  const [showPopup, setShowPopup] = useState<boolean>(false);

  const [message, setMessage] = useState<string>("");

  const [clientDataStatus, setClientDataStatus] = useState<
    (typeof clientDataStatuses)[keyof typeof clientDataStatuses]
  >(clientDataStatuses.loading);

  const getClientData = async (leadId: number) => {
    try {
      const { data } = await api.get<IClientData>("/api-gateway/lead", {
        params: { leadId, phone: phone ?? undefined },
      });
      console.log(`Данные успешно получены`);
      setIncomingFieldValues(data.leadData);
      setContactId(data.contactId);
      setClientDataStatus(clientDataStatuses.found);
      return true;
    } catch (error) {
      console.log(`Не удалось получить данные: ${error}`);
      setMessage(`Сделка с Id ${leadId} не найдена`);
      setShowPopup(true);
      setClientDataStatus(clientDataStatuses.notFound);
      return false;
    }
  };

  useEffect(() => {
    if (!leadId) {
      console.log(`Id сделки отсутствует`);
      setMessage(`Не получили Id сделки, невозможно выполнить поиск`);
      setShowPopup(true);
      setClientDataStatus(clientDataStatuses.notFound);
      return;
    }
    getClientData(leadId);
  }, []);

  if (clientDataStatus === clientDataStatuses.loading) {
    return <p>Поиск сделки...</p>;
  }

  if (clientDataStatus === clientDataStatuses.notFound) {
    return (
      <>
        {showPopup && (
          <InfoPopup
            message={message}
            onClose={() => setShowPopup(false)}
          ></InfoPopup>
        )}
      </>
    );
  }

  return (
    <div className="call-form">
      <div className="header">
        <button
          className={`form-button ${activeTab === "form" ? "tab active" : "tab"}`}
          onClick={() => setActiveTab("form")}
        >
          Анкета
        </button>
        <button
          className={`map-button ${activeTab === "map" ? "tab active" : "tab"}`}
          onClick={() => setActiveTab("map")}
        >
          Карта потребностей
        </button>
      </div>

      <div
        className="form-container"
        style={{ display: activeTab === "form" ? "block" : "none" }}
      >
        <CallFormTab
          leadId={leadId}
          phone={phone}
          contactId={contactId}
          incomingFieldValues={incomingFieldValues}
        ></CallFormTab>
      </div>
      <div
        className="form-map"
        style={{ display: activeTab === "map" ? "block" : "none" }}
      >
        <CallMapTab></CallMapTab>
      </div>
    </div>
  );
};

export default CallForm;
